import { getNodesFromConnection } from '../../helpers/graphql';
import { useClientHasRendered } from '../../helpers/hooks';
import {
  GetSpeciesFromList_species_edges,
  GetTopSpeciesNearLocation_topSpeciesNearLocation_edges,
} from '../../interfaces/graphql';
import { SpeciesCard } from '../Cards/SpeciesCard/SpeciesCard';
import { ContinuousCarousel } from '../Carousels/ContinuousCarousel/ContinuousCarousel';
import { Container } from '../Container/Container';

interface IProps {
  sectionTitle: string;
  clickEventSourceId: string;
  clickEventSource: string;
  topSpeciesEdgeList: GetTopSpeciesNearLocation_topSpeciesNearLocation_edges[];
  defaultSpeciesEdgeList: GetSpeciesFromList_species_edges[];
  isLoading?: boolean;
}

export const PopularSpeciesNearYou = ({
  sectionTitle,
  clickEventSourceId,
  clickEventSource,
  topSpeciesEdgeList,
  defaultSpeciesEdgeList,
  isLoading = false,
}: IProps) => {
  const clientHasRendered = useClientHasRendered();
  const sortedDefaultSpecies = defaultSpeciesEdgeList
    .map(obj => ({ ...obj, catchesCount: undefined }))
    .filter(sp => sp.node && sp.node.catches.totalCount)
    .sort((sp1, sp2) => (sp2.node?.catches.totalCount || 0) - (sp1.node?.catches.totalCount || 0));

  const speciesList = topSpeciesEdgeList.length > 0 ? topSpeciesEdgeList : sortedDefaultSpecies;

  const getTestId = (): string => {
    if (isLoading || !clientHasRendered) {
      return 'PopularSpeciesContentLoader';
    }
    if (topSpeciesEdgeList.length > 0) {
      return 'PopularSpeciesNearYou';
    }
    return 'PopularSpeciesDefaultSpecies';
  };

  return (
    <div className="bg-lake-fog" id="other-species-section">
      <Container className="py-sm">
        <ContinuousCarousel
          dataTestId={getTestId()}
          title={sectionTitle}
          outerClass="!mt-0"
          showContentLoader
          isLoading={!clientHasRendered || isLoading}
          contentLoaderKey="species-near-you"
        >
          {speciesList.map(({ catchesCount, node: species }, index) => {
            if (species) {
              const images = getNodesFromConnection(species.exampleCatchWithImage?.post.images);
              const imageUrl = images[0]?.url || '';
              const imageWidth = images[0]?.width || 0;
              const imageHeight = images[0]?.height || 0;
              return (
                <SpeciesCard
                  key={`species-${species._id}`}
                  speciesId={species._id}
                  name={species.displayName}
                  imageUrl={imageUrl}
                  imageWidth={imageWidth}
                  imageHeight={imageHeight}
                  clickEventPosition={index}
                  clickEventSourceId={clickEventSourceId}
                  clickEventSource={clickEventSource}
                  numberCaught={catchesCount}
                />
              );
            }
            return <></>;
          })}
        </ContinuousCarousel>
      </Container>
    </div>
  );
};
